import { isTypeLogoWithQuoteSection } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulLogoWithQuoteSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeLogoWithQuoteSection(entry)) {
    return null;
  }

  return <div>ContentfulLogoWithQuoteSection</div>;
};

export default ContentfulLogoWithQuoteSection;
